"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var Ethereum = function Ethereum(props) {
  return react_1.default.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    version: "1.1",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 784.37 1277.39"
  }, props), react_1.default.createElement("g", null, react_1.default.createElement("path", {
    fill: "#343434",
    d: "M392.07 0L383.5 29.11 383.5 873.74 392.07 882.29 784.13 650.54z"
  }), react_1.default.createElement("path", {
    fill: "#8C8C8C",
    d: "M392.07 0L0 650.54 392.07 882.29 392.07 472.33z"
  }), react_1.default.createElement("path", {
    fill: "#3C3C3B",
    d: "M392.07 956.52L387.24 962.41 387.24 1263.28 392.07 1277.38 784.37 724.89z"
  }), react_1.default.createElement("path", {
    fill: "#8C8C8C",
    d: "M392.07 1277.38L392.07 956.52 0 724.89z"
  }), react_1.default.createElement("path", {
    fill: "#141414",
    d: "M392.07 882.29L784.13 650.54 392.07 472.33z"
  }), react_1.default.createElement("path", {
    fill: "#393939",
    d: "M0 650.54L392.07 882.29 392.07 472.33z"
  })));
};
exports.default = Ethereum;